import React from 'react'
import Helmet from 'react-helmet'
import DocHeader from '../components/DocHeader'
import Footer from '../components/Footer'

import icon32 from '../../assets/favicon.png'

const Layout = ({ children, data }) => (
  <>
    <Helmet
      title="Suggested documentation"
      meta={[
        {
          name: 'description',
          content:
            "Suggested helps you collect, manage and centralize customer feedback. Show customers what you're working on with a roadmap. Annouce new updates with a product changelog.",
        },
        {
          name: 'keywords',
          content: 'Customer feedback, public roadmap, product changelog',
        },
      ]}
      link={[{ rel: 'icon', type: 'image/png', href: icon32, sizes: '32x32' }]}
      script={[{ src: 'https://kit.fontawesome.com/2026537813.js' }]}
    ></Helmet>
    <DocHeader siteTitle={'Suggested documentation'} />
    {children}
    <Footer />
  </>
)

export default Layout
